import React, {Component} from 'react';
import {BrowserRouter as Router, Redirect, Route, Switch} from 'react-router-dom';

import AggregateView from '../aggregate/AggregateView';
import ItemListView from '../itemlist/ItemListView';
import Header from '../header/Header';
import NoWarehouseSelectedView from '../homepage/NoWarehouseSelectedView';
import Footer from '../footer/Footer';
import RouteValidator from './RouteValidator';
import WorkViewRouteGuard from './WorkViewRouteGuard';
import NotFound404 from '../error/NotFound404';
import WarehouseIdsProvider from '../provider/WarehouseIdsProvider';
import APIGatewayClientProvider from '../provider/APIGatewayClientProvider';
import IsItDown from '../isItDown/IsItDown';
import {
    AGGREGATE_VIEW_URL,
    DEFAULT_AGGREGATE_VIEW,
    HOME_URL,
    ITEM_LIST_URL,
    RouteUtilities,
    SEARCH_URL,
    WAREHOUSE_ID_URL,
    WORK_AGGREGATE_VIEW_URL
} from './RouteDefinitions';

export {
    AGGREGATE_VIEW_URL,
    DEFAULT_AGGREGATE_VIEW,
    DWELL_TIME_URL,
    HOME_URL,
    ITEM_LIST_URL,
    POST_RECEIVE_URL,
    POST_RECEIVE_WORK_VIEW_URL,
    PRE_RECEIVE_URL,
    PRE_RECEIVE_WORK_VIEW_URL,
    SEARCH,
    SEARCH_URL,
    WAREHOUSE_ID_KEY,
    WAREHOUSE_ID_URL,
    WORK_AGGREGATE_VIEW_URL
} from './RouteDefinitions';

/**
 * Class to handle the Routing of the application via ReactRouter
 */
export default class AppRouter extends Component {

    componentDidMount() {
        IsItDown.load();
    }

    render() {
        return (
            <Router>
                <APIGatewayClientProvider>
                    <WarehouseIdsProvider>
                        <Header/>
                        <div className="body-container flex-shrink-0">
                            <Switch>
                                <Route exact path={HOME_URL} component={NoWarehouseSelectedView}/>
                                <Route exact path={SEARCH_URL} component={RouteValidator(ItemListView)}/>
                                <Route exact path={WORK_AGGREGATE_VIEW_URL} component={WorkViewRouteGuard(RouteValidator(AggregateView))}/>
                                <Route exact path={AGGREGATE_VIEW_URL} component={RouteValidator(AggregateView)}/>
                                <Route exact path={ITEM_LIST_URL} component={RouteValidator(ItemListView)}/>
                                <Redirect exact from={WAREHOUSE_ID_URL} to={DEFAULT_AGGREGATE_VIEW}/>
                                <Route path="*" component={NotFound404}/>
                            </Switch>
                        </div>
                        <Footer/>
                    </WarehouseIdsProvider>
                </APIGatewayClientProvider>
            </Router>
        );
    }

    static isSearchView(currentView) {
        return RouteUtilities.isSearchView(currentView);
    }

    static isPreReceiveAggregateView(currentView) {
        return RouteUtilities.isPreReceiveAggregateView(currentView);
    }

    static isPostReceiveAggregateView(currentView) {
        return RouteUtilities.isPostReceiveAggregateView(currentView);
    }

    static isDwellTimeAggregateView(currentView) {
        return RouteUtilities.isDwellTimeAggregateView(currentView);
    }

    static isWorkView(currentView) {
        return RouteUtilities.isWorkView(currentView);
    }

    static generateNewUrl(warehouseId, view) {
        return RouteUtilities.generateNewUrl(warehouseId, view);
    }
}
